
<template>
  <div>
    <Header />
    <v-container>
      <v-layout row wrap justify-center fill-height>
        <v-flex md12 mb-2 v-if="skus.length > -1">
          <v-card>
            <v-card-title>SKU Verteilung - v2</v-card-title>
            <v-card-text>
              <div style="block" v-for="sku in skus" :key="sku">
                <h3>{{ sku.name }}: {{ sku.count }}</h3>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex md12>
          <v-card class="elevation-5">
            <v-card-text primary-title>
              <h1 class="display-1">
                <v-icon @click="$router.go(-1)" large class="mr-2"
                  >arrow_back</v-icon
                >Bestellungen
              </h1>
              <v-spacer></v-spacer>
              <v-btn
                class="secondary"
                small
                @click="fireEvent('CREATE_PACKLIST', 'babycube')"
                >Packliste anlegen</v-btn
              >

              <v-btn
                class="secondary"
                small
                @click="fireEvent('CREATE_SHIPPING', 'babycube')"
                >Versandvorbereitung</v-btn
              >

              <v-btn @click="genereate()" primary>Zip Grafik erzeugen</v-btn>

              <v-data-table
                hide-default-footer
                :must-sort="true"
                :loading="loading"
                :items-per-page="-1"
                :headers="tableHeaders"
                :items="items"
                :item-class="itemClass"
              >
                <template v-slot:body="{ items, headers }">
                  <tbody>
                    <tr
                      v-for="(item, idx) in items"
                      :key="idx"
                      :class="itemClass(item)"
                    >
                      <td v-for="(header, key) in headers" :key="key">
                        <v-edit-dialog
                          :return-value.sync="item[header.value]"
                          v-if="editBlacklist.indexOf(header.value) == -1"
                          @save="save(item)"
                          @cancel="cancel"
                          @open="open"
                          @close="close"
                          large
                        >
                          {{ item[header.value] }}
                          <template v-slot:input>
                            <v-text-field
                              v-model="item[header.value]"
                              label="Bearbeiten"
                              single-line
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>

                        <div v-else-if="header.value == 'id'">
                          {{ items.indexOf(item) }}
                        </div>

                        <div v-else-if="header.value == 'reproduction'">
                          <v-btn
                            v-if="
                              item.reproduction == true ||
                              item.directShip == true
                            "
                            primary
                            @click="fireEvent('DHLSHIPPING', item.orderId)"
                            >Versenden</v-btn
                          >
                        </div>

                        <div v-else-if="header.value == 'reusable'">
                          <v-btn
                            v-if="item.reusable"
                            icon
                            @click="fireEvent('REUSE_ITEM', item.reusable)"
                          >
                            Verwenden <v-icon>check</v-icon></v-btn
                          >
                        </div>

                        <div v-else-if="header.value == 'orderItems'">
                          <v-btn
                            v-if="item.orderItems"
                            @click="fireEvent('SHOW_CART', item.orderItems)"
                          >
                            WARENKORB
                          </v-btn>
                        </div>

                        <div v-else>
                          {{ item[header.value] }}
                        </div>
                      </td>
                      <td>
                        <v-icon small @click="fireEvent('DELETE_ITEM', item)">
                          delete
                        </v-icon>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <DHLDialog />
    <ReuseDialog />
    <DeleteDialog />
    <LoadingDialog />
    <PacklistDialog />
    <ShippingDialog />
    <CartDialog />
  </div>
</template>

<script>
import Header from "../header";
import service from "@/services/ProductionService";
import router from "@/router";

import DHLDialog from "./components/DHLDialog.vue";
import ReuseDialog from "./components/ReuseDialog.vue";
import DeleteDialog from "./components/DeleteDialog.vue";
import LoadingDialog from "./components/LoadingDialog.vue";
import PacklistDialog from "./components/PacklistDialog.vue";
import ShippingDialog from "./components/ShippingDialog.vue";
import CartDialog from "./components/CartDialog.vue";

import EventBus from "@/event-bus";

//BABYCUBE Specials
import JSZip from "jszip";
import fileDownload from "js-file-download";


export default {
  name: "productionItem",
  components: {
    Header,
    DHLDialog,
    ReuseDialog,
    DeleteDialog,
    LoadingDialog,
    PacklistDialog,
    ShippingDialog,
    CartDialog,
  },
  data: () => ({
    loading: true,
    tableAttributes: [],
    items: [],
    editBlacklist: [
      "id",
      "orderId",
      "reproduction",
      "reusable",
      "sku",
      "delete",
      "orderItems",
    ],
    tableHeaders: [],
    skus: [],

    reusableItems: [],
  }),
  create() {},
  async mounted() {
    EventBus.$on("REFRESH", () => {
      this.refresh();
    });

    this.refresh();
  },
  methods: {
    fireEvent(tag, payload) {
      EventBus.$emit(tag, payload);
    },

    itemClass(item) {
      if (item.orderItems) {
        return "multiOrder";
      } else if (item.reproduction) {
        return "reproduction";
      } else if (item.reusable) {
        return "reusable";
      }
    },

    async refresh() {
      //Show Loading Dialog
      this.loading = true;
      EventBus.$emit("LOADING_START");

      this.tableAttributes = null;
      this.items = [];
      this.tableHeaders = [];
      this.reusableItems = [];
      this.skus = [];
      try {
        let data = (await service.getItem("babycube")).data;
        this.tableAttributes = Object.keys(data[0]).filter(
          (x) => x != "reproduction" && x != "orderItems"
        );

        //Build Table Headers
        for (let key of this.tableAttributes) {
          this.tableHeaders.push({
            text: key,
            value: key,
            align: "left",
            sortable: false,
          });
        }

        this.tableHeaders.push({
          text: "Warenkorb",
          value: "orderItems",
          align: "left",
          sortable: false,
        });

        //Add Static Header for DIRECT SHIPPMENT
        this.tableHeaders.push({
          text: "Direkt versenden",
          value: "reproduction",
          align: "left",
          sortable: false,
        });

        //Get reusable Items of SKU
        for (let sku of new Set(data.map((x) => x.sku))) {
          let alreadyProducedItems = (await service.getReusableItems(sku)).data;

          for (let i of alreadyProducedItems) {
            this.reusableItems.push(i);
          }
        }

        //If reusable Items avaialble -> Check if we have matches
        if (this.reusableItems.length > 0) {
          this.matchReusableItems(data);
        }

        this.items = data;

        //Build SKU Overview
        for (let item of this.items) {
          let sku = item.sku;
          if (!sku) continue;

          let isAdded = false;
          for (let s of this.skus) {
            if (s.name == sku) {
              isAdded = true;
              s.count++;
            }
          }

          if (!isAdded) this.skus.push({ name: sku, count: 1 });
        }

        this.loading = false;
        EventBus.$emit("LOADING_END");
      } catch (err) {
        console.error(err);

        if (err.response.status == 401) {
          router.replace("/auth/login");
        } else {
          console.error(err);
        }
      }
    },

    matchReusableItems(data) {
      this.tableHeaders.push({
        text: "Bereits Graviert",
        value: "reusable",
        align: "left",
        sortable: false,
      });

      for (let item of data) {
        for (let rItem of this.reusableItems) {
          if (
            (item["name"] == rItem.name ||
              item["line1"] == rItem.name ||
              item["text"] == rItem.name) &&
            item["font"] == rItem["font"]
          ) {
            //WE HAVE A MATCH
            console.log("We have a match");
            item.reusable = rItem;
          }
        }
      }
    },

    async save(item) {
      this.loading = true;
      EventBus.$emit("LOADING_START");
      try {
        await service.updateEntry('babycube', item);
      } catch (e) {
        alert(
          "Der Server kann den Vorgang nicht abschließen. Bitte versuche es erneut."
        );
      } finally {
        await this.refresh();
      }
    },

    async genereate(page = 0) {
      this.loading = true;
      let data = (await service.generateBabyCube(page)).data;
      const zip = new JSZip();
      await zip.loadAsync(data, { base64: true });
      const blob = await zip.generateAsync({ type: "blob" });
      fileDownload(blob, "Babycubes.zip", "application/zip");
      this.loading = false;
    },
  },
  breforeDestroy() {},
};
</script>

<style>
.reproduction {
  background-color: cyan;
}
.reusable {
  background-color: magenta;
  color: white;
}

.multiOrder {
  background-color: lime;
  color: white;
}
</style>
